import {useMutation, useQuery, useQueryClient} from "react-query";
import {deleteRecallCard, fetchDueRecallCardCount, fetchDueRecallCards, fetchRecallCard, fetchRecallCards, fetchRecallCardsForNote, fetchRecallStats, reviewRecallCard, saveRecallCard, updateRecallCard} from "../api/recallApi";


export function useDueRecallCardCount(token) {
    return useQuery({
        queryKey: ['recallcards', 'due', 'count'],
        queryFn: () => fetchDueRecallCardCount(token),
        enabled: !!token,
        initialData: 0,
    })
}

export function useRecallStats(token, folderId = null) {
    return useQuery({
        queryKey: folderId
            ? ['recallcards', 'stats', 'folder', folderId]
            : ['recallcards', 'stats'],
        queryFn: () => fetchRecallStats(token, folderId),
        enabled: !!token,
    })
}

export function useDueRecallCards(token) {
    return useQuery({
        queryKey: ['recallcards', 'due'],
        queryFn: () => fetchDueRecallCards(token),
        enabled: !!token,
        initialData: [],
        refetchOnMount: 'always',
    })
}

export function useRecallCards(token, folderId = null, sourceNoteId = null) {
    return useQuery({
        queryKey: sourceNoteId
            ? ['recallcards', 'note', sourceNoteId]
            : folderId
                ? ['recallcards', 'folder', folderId]
                : ['recallcards'],
        queryFn: () => fetchRecallCards(token, folderId, sourceNoteId),
        enabled: !!token,
        initialData: [],
    })
}

export function useRecallCardsForNote(token, noteId){
    return useQuery({
        queryKey: ['recallcards', 'note', noteId],
        queryFn: () => fetchRecallCardsForNote(token, noteId),
        enabled: !!token && !!noteId,
        initialData: [],
    })
}

export function useRecallCard(token, id){
    return useQuery({
        queryKey: ['recallcard'],
        queryFn: () => fetchRecallCard(token, id),
        enabled: !!token,
    })
}

export function useSaveRecallCard(token){
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (cardData) => saveRecallCard(token, cardData),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["recallcards"]})
        }
    });
}


export function useUpdateRecallCard(token){
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({recallCardId, cardData}) => updateRecallCard(token, recallCardId, cardData),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["recallcards"]});
            queryClient.invalidateQueries({queryKey: ["recallcard"]});
        }
    });
}

export function useDeleteRecallCard(token){
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (recallCardId) => deleteRecallCard(token, recallCardId),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["recallcards"]});
            queryClient.removeQueries({queryKey: ["recallcard"]});
        }
    });
}

export function useReviewRecallCard(token){
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({recallCardId, reviewData}) => reviewRecallCard(token, recallCardId, reviewData),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["recallcards"]});
            queryClient.invalidateQueries({queryKey: ["recallcard"]});
        }
    });
}
